(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bilan-publier-cci', {
                parent: 'bilan-cci',
                url: '/bilan-publier-cci',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CCIR', 'ROLE_USER'],
                    pageTitle: 'bhsApp.bilan.publication.bilans.publierBilans'
                },
                views: {
                    'content@bhs': {
                        templateUrl: 'app/bilan/cci/publication/publication-bilans.html',
                        controller: 'PublicationBilansController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('publicationBilans');
                        $translatePartialLoader.addPart('bilanNational');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
